
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const dtUpdate = require ('./sale-dt-update')
const timeDate = require ('../../../../../js-handler/time-date')


export const tableDetail = {
    entity: 'sale',//name table on the db
    dest: 'sale',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"sale", "elem":"fullcont", "id":"sale-fullcont", "act":"selectOne", "entity":"sale", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"sale", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"sale", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["sale.code","customer.name","purchase.code","item.name","item.brand"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ 
    
    //console.log('organizeRow>',data)

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' }, 
                                                { label:'', span: '' },    
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }
   

    data.forEach((elem)=>{

     //   const  statusStyle  = dtUpdate.getStatusStyle(elem);
        const  statusshippingstyle  = dtUpdate.getstatusshippingtyle(elem);
        const  statuspaymentstyle  = dtUpdate.getstatuspaymentstyle(elem);
     


        let shipping_date = new Date(elem.shipping_date);
        let shipping_time="";
        if (isNaN(shipping_date.getTime())) {
            shipping_time = 'No Time';
        }else{
            shipping_time = timeDate.friendlyTime(elem.shipping_time);
        }

        newData.push(
                {   id: elem.id,   colum: [  
                    { label: elem.name, span: elem.code,
                                                style:{ 
                                                    tdClass:'tdWithAvatar', 
                                                    avatar: elem.customerAvatar,
                                                    avatarColor: elem.customerAvatarColor, 
                                                    avatarColorLetter: elem.customerAvatarColorLetter, 
                                                    avatarLetter: elem.customerAvatarLetter   
                                                    
                                                } },
                                             { label: elem.qty + ' Units', span: elem.grand_total_dt }, 
                                             { label: timeDate.friendlyDate(elem.sale_date_td), span: timeDate.friendlyDate(elem.due_date_td)}, 
                                             { label: timeDate.friendlyDate(elem.packing_slip_last_printed), 
                                                span: timeDate.friendlyTime(elem.packing_slip_last_printed_time)}, 
                                             { label: statusshippingstyle.label_top, span: statusshippingstyle.desc,
                                                style:{ 
                                                    tdClass:`tdWithIcon ${statusshippingstyle.icon.color}`,  
                                                    svg:`./css/svg.svg#${statusshippingstyle.icon.svg}`,
                                                } }, 
                                             { label: statuspaymentstyle.label_top, span: statuspaymentstyle.desc,
                                                style:{ 
                                                    tdClass:`tdWithIcon ${statuspaymentstyle.icon.color}`,  
                                                    svg:`./css/svg.svg#${statuspaymentstyle.icon.svg}`,
                                                } }]    
                }
        )
        /*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/


export function organizeRowEntityChange(data) {
    return data.map(elem => {
        const avatar = elem.avatar || "css/img/pic/person.svg";
        const parsedChanges = JSON.parse(elem.changes);
        const changesInputs = Array.isArray(parsedChanges.input) ? parsedChanges.input : [];
        const changesMt = Array.isArray(parsedChanges.mt) ? parsedChanges.mt : [];

        const inputRows = changesInputs.map(input => {
            const from = input.elemId === "sale_form_notes" && String(input.from).length > 30
                ? "Change notes"
                : input.from;

            return `<div class="row">
                        <div class="c33">${auditValue(input.elemId)}</div>
                        <div class="c33">${auditValue(from)}</div>
                        <div class="c33">${auditValue(input.to)}</div>
                    </div>`;
        }).join("");
        const inputSection = inputRows
            ? `<entry>
                    <div class="row">
                        <div class="c33">Data</div>
                        <div class="c33">From</div>
                        <div class="c33">To</div>
                    </div>
                    ${inputRows}
                </entry>`
            : "";

        const multiTableSections = changesMt.map(renderMultiTableChange).join("");

        return `<cont>
                    <user>
                        <photo class="photo" style="background-image: url('${avatar}')"></photo>
                        <title>${auditValue(elem.user_name.trim())}</title>
                        <time>${timeDate.friendlyDate(elem.date_change) + ' | ' + timeDate.friendlyTime(elem.date_change.substring(10))}</time>
                    </user>
                    ${inputSection}
                    ${multiTableSections}
                </cont>`;
    }).join("");
}

function renderMultiTableChange(table) {
    const config = table.id === "sale_form_sale_vs_return"
        ? {
            title: "Returns",
            headers: ["Status", "Item", "Qty", "Amount", "Date", "Notes"],
            values: row => [
                row.sale_vs_itemId,
                row.lost_qty,
                moneyValue(row.lost_price),
                row.date,
                row.notes
            ]
        }
        : {
            title: "Items",
            headers: ["Status", "Items", "Units", "Qty", "Unit Price", "Total"],
            values: row => [
                row.id,
                row.selling_type,
                row.qty,
                moneyValue(row.price),
                moneyValue(row.total)
            ]
        };
    const fromRows = Array.isArray(table.from) ? table.from : [];
    const toRows = Array.isArray(table.to) ? table.to : [];
    let rows = "";

    fromRows.forEach((from, index) => {
        rows += renderMultiTableRow("From", from, config);
        if (toRows[index]) rows += renderMultiTableRow("To", toRows[index], config);
    });

    toRows.slice(fromRows.length).forEach(to => {
        rows += renderMultiTableRow("To", to, config);
    });

    return `<entry>
                <div class="row mt-8">
                    <div class="c100">${config.title}</div>
                </div>
                <div class="row">
                    ${config.headers.map(header => `<div class="c16">${header}</div>`).join("")}
                </div>
                ${rows}
            </entry>`;
}

function renderMultiTableRow(status, row, config) {
    const values = config.values(row);

    return `<div class="row">
                <div class="c16">${status}</div>
                ${values.map(value => `<div class="c16">${auditValue(value)}</div>`).join("")}
            </div>`;
}

function moneyValue(value) {
    return value === undefined || value === null || value === "" ? "" : `$${value}`;
}

function auditValue(value) {
    if (Array.isArray(value)) return value.map(auditValue).join(", ");
    if (value && typeof value === "object") return auditValue(value.displayText ?? value.id ?? "");

    return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
}







/*organizeRow*/
/*
{
    "id": "11",
    "department": "[{\"id\": \"25\", \"displayText\": \"TEST\"}]",
    "admission_date": "2022-06-01",
    "termination_date": "2003-03-03",
    "status": "Active",
    "max_hours": 100,
    "classification_level": "CL1",
    "TAL": "TAL1",
    "Proxy": "P1",
    "sendEvv": "true",
    "memberId": "101010",
    "is24hr": "",
    "patient_agrmt_hourly_payrate": "32.50",
    "rhio_consent": "",
    "rhio_consent_date": "2022-06-01",
    "privateCase": "true",
    "managed_care_plan": "MCP1",
    "N_procedureCode": "PC1",
    "N_saleRateCode": "PRC1",
    "N_procedureModCode": "PMC1",
    "insurance_contact": "IC1",
    "health_insurance_company": "HIP1",
    "notes": "1111"
}

*/
